var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-checkbox',{attrs:{"type":_vm.colour},on:{"input":function($event){return _vm.setRole($event)}},model:{value:(_vm.roleValue),callback:function ($$v) {_vm.roleValue=$$v},expression:"roleValue"}},[_vm._v(_vm._s(_vm.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }